/**
 * Keresés nagy listákban: kis-nagybetű és ékezet nélkül, hogy a "kovacs" is
 * megtalálja Kovácsot, a "TAJ 123" pedig a szóközös TAJ számot.
 */
export const normalizeSearch = (value: string | null | undefined): string =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

/**
 * Igaz, ha a keresőkifejezés minden szava megtalálható valamelyik mezőben.
 * Így a "kis u11" a Kis nevű U11-es játékosra is illik, sorrendtől függetlenül.
 */
export const matchesSearch = (query: string, ...fields: (string | null | undefined)[]): boolean => {
  const words = normalizeSearch(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = fields.map(normalizeSearch).join(' ');
  // A számokat szóközök nélkül is nézzük: "123456789" illik a "123 456 789" TAJ-ra
  const compact = haystack.replace(/\s+/g, '');
  return words.every((w) => haystack.includes(w) || compact.includes(w));
};
